
import { computed, defineComponent } from "vue";
import { useRoute } from "vue-router";
import { routeNames } from "@/router";
import store from "@/stores";
import Header from "@/components/Header.vue";

export default defineComponent({
  name: "AppUser",
  components: {
    Header,
  },
  setup() {
    const route = useRoute();
    const isLogin = computed(() => route.name == routeNames.Login);
    const isTop = computed(() => route.name == routeNames.Top);
    const resource = store.useResource();

    return {
      isTop,
      isLogin,
      ...resource,
    };
  },
});
